/**
 * Type guard function used in switch-case statements to ensure all possible values are handled,
 * preventing accidental omission of cases.
 * Throws an error if an invalid value is provided.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const exhaustiveMatchGuard = (_: never): never => {
    throw new Error('Invalid value provided');
};
